import Crud from '../views/Equipe/Crud'
import Entity from '../views/Equipe/Add'

let routes = {
    path: '/equipes',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/equipes/add',
            name: 'Newequipe',
            component: Entity
        },
        {
            path: '/equipes/edit/:id?',
            name: 'Editequipe',
            component: Entity
        },
        {
            path: '/equipes',
            name: 'list-equipes',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Equipes',
                breadcrumb: [
                    {
                        text: 'Equipes',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
